<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <!-- <input type="text" v-model="query.keyWord" />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleCopy(scope.row)" class="color-blue">追加申报</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
      :cell-class-name="checkDel" style="width: 100%" @selection-change="handleSelectionChange"
      stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>

      <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
      <el-table-column width="180" prop="productName" label="产品"></el-table-column>
      <el-table-column prop="specName" width="150" label="规格型号"></el-table-column>
      <el-table-column prop="manufacturerName" width="180" label="生产厂家"></el-table-column>
      <el-table-column prop="productRegistCertName" width="180" label="注册证名称"></el-table-column>
      <el-table-column prop="productRegistCertNo" width="180" label="注册证号"></el-table-column>
      <el-table-column prop="minUnit" width="80" label="最小单位"></el-table-column>
      <el-table-column prop="annual" width="80" label="所属年度"></el-table-column>
      <el-table-column prop="number" width="100" label="申报数量"></el-table-column>
      <el-table-column prop="purchaseNumber" width="100" label="已采购数量"></el-table-column>
      <el-table-column prop="warnNumber" width="100" label="预警阈值"></el-table-column>
      <el-table-column prop="volumePurchaseNos" label="申请单号" min-width="110">
        <template slot-scope="scope">
          <template v-if="
            scope.row.volumePurchaseInfos && scope.row.volumePurchaseInfos.length > 0
          ">
            <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
              <div slot="content" class="">
                <div class="tooltip-text" v-for="item in scope.row.volumePurchaseInfos" :key="item.id">
                  {{ item.no }}
                </div>
              </div>
              <span class="td-overflow-hidden">{{ scope.row.volumePurchaseNos }}</span>
            </el-tooltip>
          </template>
          <template v-else>
            <span class="td-overflow-hidden">{{ scope.row.volumePurchaseNos }}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码"
        width="200"></el-table-column>
      <el-table-column prop="operation" fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" v-preventReClick @click="handleCopy(scope.row)" class="color-blue">追加申报</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
  
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import { GetVolumeDeclarationDetails } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import Info from './info';
import { AnnualOptions, ApproveStatusOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      AnnualOptions: AnnualOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "产品信息",
          type: "input",
          code: "keyWord",
        },

        {
          name: "年度",
          type: "select",
          code: "annual",
          data: AnnualOptions,
          // defaultValue: 2022
        },
        {
          name: "注册证",
          type: "select",
          code: "productRegistCertId",
          filterMethod: this.getProductRegistCerts,
          data: [],
        },
        {
          name: "注册证号",
          type: "input",
          code: "productRegistCertNo",
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
      ],

      finishVisible: false,
      finishForm: {},
      finishFormRules: {
        reason: [{ required: true, message: "请输入终止原因", trigger: "blur" }],
      },
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData() {
      this.loading = true;
      GetVolumeDeclarationDetails(this.query)
        .then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 重置
    reset() {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.getData();
    },
    queryChange() {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    filterChange(query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
    handleCopy(row) {
      // this.isCopy = true
      // this.showEditDialog(row)
      // this.$router.push("/purchase-apply-edit?formMode=2&isCopy=1&id=" + row.id);
      this.routePushWithParams("/volume-purchase-edit", this.query, {
        formMode: 2,
        id: row.id,
        isCopy: 1,
      });
    },

    checkDel({ row, column, rowIndex, columnIndex }) {
      // 某一行已采购数量 > 预警阈值
      if (parseFloat(row.purchaseNumber) > parseFloat(row.warnNumber)) {
        return "red"; //class名称
      }
    },
  },
  created() {
    // 分页组件默认值需要早created
    if (this.$route.params && JSON.stringify(this.$route.params) != "{}") {
      this.query = this.$route.params;
    }
  },
  mounted() {
    // 查询组件默认值需要在mounted
    // console.log(this.$route, 'route')
    if (this.$route.params && JSON.stringify(this.$route.params) != "{}") {
      this.$refs["selectFilter"].query = this.query;
    }
    // if (!this.$route.params.state) {
    //   // this.query.state = 0
    //   // this.$refs["selectFilter"].query.stateName = 0
    // }

    this.getData();
  },
};
</script>

<style scope>
.el-table .red {
  background: #f0a6a6;
}
</style>
